import React, { FC } from 'react';
import { HostProvider } from '../utils/HostProvider';

interface Props {
  key: string;
  text: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
}

const Checkbox: FC<Props> = ({ key, text, value, onChange, checked }) => {
  const isEroski = HostProvider.isEroski();
  return (
    <label
      htmlFor={`filter-check-${value?.replace(' ', '-')}`}
      className="checkbox"
    >
      <div
        className={` checkbox__check  ${
          isEroski ? ` ` : `checkbox__check--caprabo `
        }  ${checked ? ` checkbox__check--checked` : ''}`}
      />
      <input
        id={`filter-check-${value?.replace(' ', '-')}`}
        key={key}
        className="checkbox__input"
        type="checkbox"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
      />
      <p>{text}</p>
    </label>
  );
};

export default Checkbox;
